import React from "react"
import { ChatConversation } from "pagesV2/pro/Messages/ChatConversation"

export const ClientMessages = () => {
  return (
    <div className="flex-column flex-grow-1">
      <ChatConversation />
    </div>
  )
}
